import { createContext } from 'react'

export const CentrifugeContext = createContext(null)
